import authService from '@/services/authService';
// import authService from '@/services/dummyAuthService';
/* eslint no-param-reassign: 0 */

/**
 * This exposes the Auth0 plugin
 */

export default {
  install(Vue) {
    Vue.prototype.$auth0 = authService;

    Vue.mixin({
      created() {
        if (this.handleLoginEvent) {
          authService.addListener('loginEvent', this.handleLoginEvent);
        }
      },

      destroyed() {
        if (this.handleLoginEvent) {
          authService.removeListener('loginEvent', this.handleLoginEvent);
        }
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/plugins/auth0.js